export default "__VITE_ASSET__BH_V8uqS__"